import { ChangeDetectionStrategy, Component, forwardRef, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { cardS } from '@atmi/core/models';
import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => EdtFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => EdtFormComponent),
    },
  ],
  selector: 'app-edt-form',
  styleUrls: ['./edt-form.component.scss'],
  templateUrl: './edt-form.component.html',
})
export class EdtFormComponent extends BaseCtrlValueAccessorFormArrayComponent<cardS.EDT> implements OnDestroy, OnInit {

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage EDT without a control');
    }

    const control = this.formManager.makeForm(cardS.EDTMeta, {} as cardS.EDT);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage EDT without a control');
    }

    this.form.removeAt(index);
  }
}
